import React from "react";
import {FormattedMessage} from "react-intl";
import {Link} from "react-router-dom";

import Typography from "@material-ui/core/Typography";

import Container from "../../../../common/components/common/Container";
import Paper from "../../../../common/components/common/Paper";

class ConsumerExportData extends React.Component {

    render() {
        return (
            <Container size={Container.SIZE_TINY}>
                <Paper padding>
                    <Typography
                        paragraph
                        variant="h6">
                        <FormattedMessage
                            id="exportData"
                            defaultMessage="Export Data"/>
                    </Typography>

                    <Typography
                        variant="body1">
                        <FormattedMessage
                            id="consumer-export-data.exportDataText"
                            defaultMessage="To export data please send an email."/>
                    </Typography>

                    <Link to="/consumer/contact">
                        <FormattedMessage
                            id="contact"
                            defaultMessage="Contact"/>
                    </Link>
                </Paper>
            </Container>
        );
    }

}

export default ConsumerExportData;
